import { Card as RaCard, CardProps as RaCardProps } from '@mui/material';

export type CardProps = RaCardProps;

export const Card = RaCard;
